import React from "react";

const SvgClose = props => <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}><path opacity={0.9} d="M9.353 8.646l-.707.707L15.284 16l-6.636 6.646.706.708L16 16.716l6.646 6.636.708-.706L16.716 16l6.636-6.646-.706-.708L16 15.284 9.354 8.648z" stroke="currentColor" /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/close_fb9a4e.svg";
export { SvgClose as ReactComponent };